<ng-container *ngIf="videos?.length > 0 && pdpStaticContent">
  <tmo-gallery
    [itemArray]="videos"
    [isVideo]="true"
    [dynamicId]="'videoThumbnail'"
    [pageTitle]="pdpStaticContent?.videos"
  ></tmo-gallery>
  <div class="row m-t-xl">
    <div class="col-12">
      <hr class="divider" />
    </div>
  </div>
</ng-container>
